import { apiClient } from '../services/api-client';

/**
 * POSTs to a foodcourt endpoint.
 *
 * The response is unvalidated JSON, so `TResponse` is an unchecked claim confined
 * to this boundary rather than validation — see the longer note in
 * `LyticsFetcher`.
 *
 * Defaults to `unknown` because these endpoints do not share a reply shape: `POST
 * /order/` answers with `FoodOrderCreateResponse` (`statusCode`/`errorMessage`) while
 * `POST /order/sb` answers with the RFC 7807-shaped `FoodOrderSubmitResponse`. Each
 * reader names the one it expects.
 *
 * `body` is `unknown`: the call sites pass unrelated payloads and it is serialised
 * without being read here.
 */
const FoodPoster = async <TResponse = unknown>(
  endPoint: string,
  token: string,
  data: unknown,
): Promise<TResponse> => {
  const result = await apiClient.post<TResponse>(
    import.meta.env.VITE_FOODCOURT_API_NAME,
    endPoint,
    {
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      },
      body: data,
    },
  );
  return result;
};

export default FoodPoster;
